import { useTranslation } from 'next-i18next';
import { cn } from '@zep/utils';
export function DiscountBadge({
  discountRate
}: {
  discountRate: number;
}) {
  const {
    t
  } = useTranslation(['subscription']);
  return <span className={cn('rounded-[3px] bg-gradient-to-br from-[#FF7874] to-[#FF9A5C] px-[4px] text-[11px] font-[700] text-white', 'leading-[20px]')} data-sentry-component="DiscountBadge" data-sentry-source-file="DiscountBadge.tsx">
      {t('subscription:payment.duration.discount', {
      defaultValues: '{amount}% 할인',
      amount: discountRate
    })}
    </span>;
}